// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: "cac96188-0e95-4195-bee7-ad043ae3f400",
    authority:
      "https://lifejuntoati.b2clogin.com/lifejuntoati.onmicrosoft.com/B2C_1_signInsignUpV2",
    knownAuthorities: ["lifejuntoati.b2clogin.com"],
    //local
    // redirectUri: "https://localhost:44396",
    // postLogoutRedirectUri: "https://localhost:44396",
    //DEV
    // redirectUri: "https://lisvdsewe.life.com.ec:4461",
    // postLogoutRedirectUri: "https://lisvdsewe.life.com.ec:4461",
    //PROD
    redirectUri: "https://vss.life.com.ec",
    postLogoutRedirectUri: "https://vss.life.com.ec",
  },
};

// Scopes you add here will be prompted for consent during login
export const loginRequest = {
  // scopes: ["https://fabrikamb2c.onmicrosoft.com/helloapi/demo.read"]
  scopes: [
    "https://lifejuntoati.onmicrosoft.com/apiBiblioteca/user/biblioteca.read",
  ],
};
